import React, { useState, useEffect, useCallback } from "react";
import { useNavigate } from "react-router-dom";

import { MissionScreenerSubCard, MissionSubCardHorizontalDivider } from "./MissionLayoutComponents";
import { useAlert } from 'react-alert';

import Button from "../../common_components/Button";
import Timeline from "./Timeline";
import CenteredLoadingIcon from "../../common_components/CenteredLoadingIcon";
import { Survey, Model, StylesManager } from "survey-react";
import { userSurveyTheme } from "./SurveyThemeJson";
import { userSurveyThemeMobile } from "./SurveyThemeJsonMobile";
import SurveyAPI from "../../../api/api_calls/SurveyAPI";
import { attachPasteDetection } from "../../../../../utility_components/SurveyFunctions";



function MissionScreener({ mission, userMissionState, refreshMissionStatus }) {

    return (
        <>
            <MissionScreenerSubCard>
                <Timeline mission={mission} userMissionState={userMissionState} />
                <MissionSubCardHorizontalDivider showMobile={true} showDesktop={false} />
            </MissionScreenerSubCard>
            <ScreenerCard mission={mission} refreshMissionStatus={refreshMissionStatus} />
        </>

    )
}

function ScreenerCard({ mission, refreshMissionStatus }) {
    const navigate = useNavigate();
    const alert = useAlert();
    const [screenerModel, setScreenerModel] = useState(null);
    const [loadingScreener, setLoadingScreener] = useState(true);
    const [screenerId, setScreenerId] = useState(null);
    const [screener, setScreener] = useState(null);
    const missionId = mission.id;

    const onScreenerComplete = useCallback(async (sender) => {
        const response = await SurveyAPI.create_response(sender.data, missionId, screenerId, navigate)

        if (response.success) {
            if (response.pass) {
                alert.show("You've passed the screener!", { type: 'success' })
                refreshMissionStatus();
            } else {
                alert.show("Unfortunately, you're not the target audience", { type: 'error' })
                refreshMissionStatus();
            }
        } else {
            alert.show("Unable to submit survey. Please contact info@despark.io", { type: 'error' })
        }
    }, [missionId, screenerId, refreshMissionStatus, alert, navigate]);

    // First effect just loads the survey model and sets the ID
    useEffect(() => {
        const GetScreener = async () => {
            const response = await SurveyAPI.show_screener(missionId);

            if (response.success) {
                const tempScreener = new Model(response.survey);
                setScreenerModel(tempScreener);
                setScreenerId(response.survey_id);
            } else {
                alert.show("Unable to load screener. Please refresh the page and try again. If the issue persists, contact info@despark.io", { type: 'error' })
            }
        }

        GetScreener();
    }, [missionId]);

    // Second effect sets up the screener with the callback once we have both pieces
    useEffect(() => {
        if (screenerModel && screenerId) {
            screenerModel.applyTheme(innerWidth < 840 ? userSurveyThemeMobile : userSurveyTheme);
            screenerModel.onComplete.add(onScreenerComplete);
            screenerModel.completeText = "Continue";
            screenerModel.nextText = "Continue";
            // New --- install paste detection
            attachPasteDetection(screenerModel);
            setScreener(screenerModel);
            setLoadingScreener(false);
        }
    }, [screenerModel, screenerId, onScreenerComplete]);

    return (
        <div className="screener-container-card">
            {loadingScreener ? <CenteredLoadingIcon /> : <Survey model={screener} />}
        </div>
    )
}


export default MissionScreener;